import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';

import { filterBoolean } from '@core/common-legacy';

import { FormConfigHttpClient } from './form-config-http.client';
import { FormConfigActions, FormConfigSelectors } from './form-config.store';
import type { FormConfig, FormConfigCreateParams } from '../../../types';

@Injectable({ providedIn: 'root' })
export class FormConfigStoreService {
  private readonly store = inject(Store);
  private readonly httpClient = inject(FormConfigHttpClient);

  public getFormConfigs(integrationKind: string): Observable<FormConfig[]> {
    return this.store
      .select(FormConfigSelectors.entities({ scope: integrationKind }))
      .pipe(filterBoolean);
  }

  public getFormConfigsLoading(integrationKind: string): Observable<boolean> {
    return this.store.select(
      FormConfigSelectors.isPending({
        scope: integrationKind.toString(),
      }),
    );
  }

  public fetchFormConfigs(integrationKind: string): void {
    this.store.dispatch(
      FormConfigActions.fetchCollection({
        payload: { scope: integrationKind.toString() },
      }),
    );
  }

  public createFormConfigs(
    integrationKind: string,
    params: FormConfigCreateParams[],
  ): Observable<FormConfig[]> {
    return this.httpClient.createFormConfigs(integrationKind, params);
  }

  public deleteFormConfig(integrationKind: string, formConfigId: number): Observable<any> {
    return this.httpClient.deleteFormConfig(integrationKind, formConfigId);
  }
}
